'use client';

import { useEffect, useState } from 'react';

import { StyledIcon } from './StyledIcon';

import { resolveClassIconPath } from '@/editor/core/classHelpers';


interface ClassIconImgProps {
  /** Icon name as returned by `getEditorClassIcon()`, e.g. `'Icon_SoundResource'`. */
  iconName: string | null | undefined;
  size?: number;
  className?: string;
}

const resolvedCache = new Map<string, string | undefined>();

/**
 * Resolves an engine icon name (e.g. `'Icon_SoundResource'`) to its public URL and renders
 * it with the same `StyledIcon` masking used elsewhere for class icons.
 */
export const ClassIconImg = ({ iconName, size = 12, className }: ClassIconImgProps) => {
  const [src, setSrc] = useState<string | undefined>(() =>
    iconName ? resolvedCache.get(iconName) : undefined
  );

  useEffect(() => {
    if (!iconName) return;
    if (resolvedCache.has(iconName)) {
      setSrc(resolvedCache.get(iconName));
      return;
    }
    resolveClassIconPath(iconName).then(path => {
      resolvedCache.set(iconName, path);
      setSrc(path);
    });
  }, [iconName]);

  if (!src) return null;

  return <StyledIcon src={src} alt={iconName ?? ''} width={size} height={size} className={className} />;
};
ClassIconImg.displayName = 'ClassIconImg';
